import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import submit from "submit-form";
import { useEffect, useState } from "react";
import SvgIcon from "../../../../../parts/SvgIcon";
import { generateWeeks } from "../body-composition.helper";
import useClickOutside from "../../../../../hooks/useClickOutside";

const DateDropdownNew = ({ startDate, endDate, calendarday }) => {
  const { t } = useTranslation("athlete-portal");
  const dropdownRef = useRef(null);
  const [year, setYear] = useState(moment(startDate).year());
  const [dropdownOpened, setDropdownOpened] = useState(false);
  useClickOutside(
    dropdownRef,
    () => {
      setDropdownOpened(false);
    },
    dropdownOpened
  );
  const [yearData, setYearData] = useState([]);
  const handleAddYear = () => {
    setYear(year + 1);
  };

  const handleSubtractYear = () => {
    setYear(year - 1);
  };
  const getYearData = (year) => {
    const monthsData = moment.months().map((monthName, index) => {
      const weeks = generateWeeks(year, index, calendarday);
      return {
        name: monthName,
        weeks,
      };
    });
    return monthsData;
  };
  const weekFormat = "MMM D";
  const headerFormat = "YYYY-MM-DD";

  const handleOpen = (e) => {
    e.preventDefault();
    setDropdownOpened(!dropdownOpened);
  };
  useEffect(() => {
    setYearData(getYearData(year));
  }, [year]);

  const updateWeek = (startDay, endDay, selectedWeek) => {
    setDropdownOpened(false);
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        startDay: startDay.format(headerFormat),
        endDay: endDay.format(headerFormat),
        selectedWeek,
      },
    });
  };
  return (
    <details id="dropdown-double" role="list" open ref={dropdownRef}>
      <summary onClick={handleOpen}>
        <p>{moment(startDate).format("MMM YYYY")}</p>
        <SvgIcon
          src={
            dropdownOpened ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"
          }
        />
      </summary>
      <div className={dropdownOpened ? "opened" : ""}>
        <header>
          <span>
            <b>{year}</b>
          </span>
          <div>
            <button
              data-button-type="text-white"
              data-icon-only
              onClick={handleSubtractYear}
            >
              <SvgIcon src="/img/new-icons/arrow-left.svg" />
            </button>
            <button
              data-button-type="text-white"
              data-icon-only
              onClick={handleAddYear}
            >
              <SvgIcon src="/img/new-icons/arrow-right.svg" />
            </button>
          </div>
        </header>
        <ul role="listbox">
          {yearData.map((month, index) => {
            return (
              <li>
                <details open>
                  <summary>
                    <span>{month.name}</span>
                    <SvgIcon src="/img/new-icons/arrow-right.svg" />
                  </summary>
                  <ul role="list">
                    {month.weeks.map((week) => {
                      return (
                        <li
                          onClick={() => {
                            updateWeek(week.start, week.end, week.number);
                          }}
                        >
                          <span>{t("bodyComposition.dateDropdown.week")} {week.number}</span>
                          <span>
                            <b>
                              {week.start.format(weekFormat)} -{" "}
                              {week.end.format(weekFormat)}
                            </b>
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </details>
              </li>
            );
          })}
        </ul>
      </div>
    </details>
  );
};

export default DateDropdownNew;
